import PrivacyPolicy from './privacy';

export default PrivacyPolicy;